<template>
    <div class="row">
        <div class="col">
            <div class="card card-form company-card">
                <div class="card-header insurance">
                    <div class="row">
                        <div class="col-12">
                            <div class="pull-left">
                                <span><i class="fa fa-list"></i> {{$t('company.insurance.label')}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="form-group">
                                <label>{{$t('company.field.dataNum')}} <span class="red">*</span></label>
                                <input type="text" class="form-control"
                                       v-model="compInsurance.dataNum"
                                       :class="{invalid: $v.compInsurance.dataNum.$error}"
                                >
                                <div class="red" v-if="!$v.compInsurance.dataNum.required">{{$t('company.validation.dataNum')}}</div>
                                <div class="red" v-if="!$v.compInsurance.dataNum.maxLength">{{$t('company.validation.dataNumConfirm')}}</div>
                            </div>
                            <div class="form-group">
                                <label>{{$t('company.field.giveName')}} <span class="red">*</span></label>
                                <textarea type="text" class="form-control"
                                          v-model="compInsurance.giveName"
                                          :class="{invalid: $v.compInsurance.giveName.$error}"
                                ></textarea>
                                <div class="red" v-if="!$v.compInsurance.giveName.required">{{$t('company.validation.giveName')}}</div>
                                <div class="red" v-if="!$v.compInsurance.giveName.maxLength">{{$t('company.validation.giveNameConfirm')}}</div>
                            </div>
                            <div class="form-group">
                                <label>{{$t('company.field.startDate')}} <span class="red">*</span></label>
                                <datepicker class="form-control" format="dd/MM/yyyy" v-model="startDate"
                                            :clear-button="false"
                                            :class="{invalid : $v.startDate.$error}"
                                ></datepicker>
                                <div class="red" v-if="!$v.startDate.required">{{$t('company.validation.startDate')}}</div>
                            </div>
                            <div class="form-group">
                                <label>{{$t('company.field.endDate')}} <span class="red">*</span></label>
                                <datepicker class="form-control" format="dd/MM/yyyy" v-model="endDate"
                                            :clear-button="false"
                                            :class="{invalid : $v.endDate.$error}"
                                ></datepicker>
                                <div class="red" v-if="!$v.endDate.required">{{$t('company.validation.endDate')}}</div>
                            </div>
                        </div>
                        <drop-zone code="companyInsurancePictureFile_"
                                   label="company.field.companyInsurancePicture"
                                   view="LOGO"
                                   folder="Profile"
                                   subFolder="General"
                                   :addRemoveLinks="hasCreate"
                                   :editable="hasCreate"
                                   :data="companyInsuranceFiles"
                                   @change="(files) => {compInsurance.companyInsurancePictureFile = files[0]}"
                                   :maxFiles="1"
                                   acceptedFiles="image/*"
                                   :has-error="$v.compInsurance.companyInsurancePictureFile.id.$error"
                        ></drop-zone>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div class="col-12">
                            <div class="text-right">
                                <router-link tag="button"
                                             class="all-btn ml-auto"
                                             v-if="!hasCreate && hasPermission('V2_COMPANY_ADD')"
                                             :to="{path: '/company/insurance/add', query: {isCreate: true}}"
                                >
                                    <i class="fa fa-plus"></i>
                                    <span>{{$t('company.field.companyCreate')}}</span>
                                </router-link>
                                <button type="button"
                                        class="all-btn add-btn"
                                        v-else-if="hasCreate && hasPermission('V2_COMPANY_ADD')"
                                        @click="save"
                                        :disabled="processing"
                                >
                                    <i class="fa fa-check"></i>
                                    <span>{{$t('action.save')}}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import DropZone from '@/views/dropZone/DropZone'
import Datepicker from 'vuejs-datepicker';
import {maxLength, required} from 'vuelidate/lib/validators';
import {formatDate, parseDate} from '@/shared/utils';

export default {
        name: "CompanyInsuranceEdit",
        components: {
            DropZone,
            Datepicker
        },
        props: {
            data: Object
        },
        data() {
            return {
                processing: false,
                compInsurance: {
                    id: null,
                    dataNum: '',
                    giveName: '',
                    beginDate: null,
                    endDate: null,
                    companyInsurancePictureFile: {}
                },
                startDate: null,
                endDate: null,
                companyInsuranceFiles: []
            }
        },
        validations() {
            return {
                compInsurance: {
                    dataNum: {
                        required,
                        maxLength: maxLength(255)
                    },
                    giveName: {
                        required,
                        maxLength: maxLength(255)
                    },
                    companyInsurancePictureFile: {
                        id: {
                            required
                        }
                    }
                },
                startDate: {
                    required
                },
                endDate: {
                    required
                }
            }
        },
        computed: {
            hasCreate() {
              return this.$route.query.isCreate != null
            }
        },
        methods: {
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                this.processing = true;

                this.compInsurance.beginDate = formatDate(this.startDate);
                this.compInsurance.endDate = formatDate(this.endDate);

                this.$http.post('/company/insurance', this.compInsurance)
                    .then(res => {
                        this.processing = false;
                        if (res.status === 200) {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.company.success'),
                                type: 'success'
                            });

                            this.$router.push('/company/profile')
                        }
                    }, ()=> {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.company.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    });
            }
        },
        created() {

        },
        watch: {
            data: {
                immediate: true,
                handler(val) {
                    if (val) {
                        this.compInsurance = val;
                        this.startDate = parseDate(val.beginDate);
                        this.endDate = parseDate(val.endDate);
                        this.companyInsuranceFiles.push(val.companyInsurancePictureFile);
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .insurance {
        background-color: #2e7d32;
    }

    .card .card-header span {
        color: white;
        font-weight: bold;
        font-size: 15px;
    }

    .card .card-footer {
        background-color: #f2f2f2;
    }

</style>